export default {
  login: {
    empleado_inexistente: 'RUT o contraseña inválidos',
    credenciales_invalidas: 'Usuario o clave incorrectos',
    invalid_user_account: 'Su cuenta no esta activa',
    block_user_account: 'Se ha bloqueado su cuenta debido a múltiples intentos fallidos de ingreso',
    disabled_user_account: 'Su cuenta se encuentra bloqueada, Intente recuperando su contraseña',
    alert_lock_account: 'Contraseña incorrecta. Restan :intentsLeft intentos para que se bloquee su cuenta',
    unlock_account_admin: 'Su cuenta fue bloqueada por el administrador',
    invalid_user: 'El usuario ingresado no existe',
    out_of_shift_time: 'No puede ingresar fuera del horario establecido',
    ip_not_allowed: 'Dirección ip no permitida',
    deprecated_portal_employee: 'Ya no se puede acceder al portal del empleado por esta vía, por favor use el NUEVO PORTAL DEL COLABORADOR',
    only_consultants: 'Login solo para consultores',
    only_inspectors: 'Login solo para Inspectores',
    inspector_expired: 'Su acceso de fiscalizador ha expirado. Contacte al administrador.',
  },
  reset_password: {
    unlock_account_admin: 'Su cuenta fue bloqueada por el administrador',
    invalid_user: 'El usuario ingresado no existe',
  },
  reset_user_account: {
    invalid_link: 'El link enviado para resetear la clave ya no es válido',
    unlock_account_admin: 'Su cuenta fue bloqueada por el administrador',
    invalid_user: 'El usuario ingresado no existe',
  },
  reset_password_confirm: {
    invalid_format_password: 'Contraseña insegura, intente nuevamente',
    invalid_link: 'El link enviado para resetear la clave ya no es válido',
    password_not_match: 'Las contraseñas ingresadas deben coincidir',
    password_invalid_format: 'El formato de la contraseña es inválido',
    unlock_account_admin: 'Su cuenta fue bloqueada por el administrador',
    invalid_user: 'El usuario ingresado no existe',
  },
  unlock_user_account: {
    unlock_account_admin: 'Su cuenta fue bloqueada por el administrador',
    invalid_user: 'El usuario ingresado no existe',
  },
};
